import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import Schedule from './pages/Schedule';
import Summaries from './pages/Summaries';
import FollowUps from './pages/FollowUps';
import Calendar from './pages/Calendar';
import CRM from './pages/CRM';
import MyDoubles from './pages/MyDoubles';
import Profile from './pages/Profile';
import { FollowUpsProvider } from './context/FollowUpsContext';
import { useAuth } from './context/AuthContext';

function App() {
  const { session, loading } = useAuth();
  
  // Check if we're on the mycal.live domain
  const isSchedulingDomain = window.location.hostname === 'mycal.live';
  
  // Always show the scheduling page for mycal.live domain regardless of auth status
  if (isSchedulingDomain) {
    return (
      <Router>
        <Routes>
          <Route path="/:name" element={<Schedule />} />
          <Route path="/" element={
            <div className="p-8 text-center">
              <h1 className="text-2xl font-bold mb-4">Welcome to Scheduling</h1>
              <p>Please use a valid scheduling link to book a meeting.</p>
            </div>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    );
  }
  
  // Regular app routing for non-scheduling domains
  return (
    <FollowUpsProvider>
      <Router>
        {loading ? (
          <div className="flex items-center justify-center min-h-screen">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
          </div>
        ) : session ? (
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="summaries" element={<Summaries />} />
              <Route path="follow-ups" element={<FollowUps />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="crm" element={<CRM />} />
              <Route path="doubles" element={<MyDoubles />} />
              <Route path="profile" element={<Profile />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </Router>
    </FollowUpsProvider>
  );
}

export default App;
